import axiosConfig from "./axiosConfig";

export interface VoaViewedResponse {
  reviewedAt: string | null;
  reviewedBy: string | null;
}

// Stamps a search result as Viewed - opened, whether or not it was edited.
// Deliberately not the review save: that would persist the panel's default
// picks as though the operator had chosen them.
const postVoaViewed = async (
  authToken: string,
  sourceRef: string
): Promise<VoaViewedResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/voa/${encodeURIComponent(sourceRef)}/viewed`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postVoaViewed;
